module.exports = __webpack_public_path__ + "img/CS-ECONew_Overview-Ad-TR_1.249f9c98.jpg";